import { BatteryFull, BatteryLow, BatteryWarning, BatteryCharging } from "lucide-react";
import { fmtTimestamp } from "@/lib/format";

// MOKO-BAT-01 · patch de visualización. Muestra la ÚLTIMA LECTURA REPORTADA por el botón MOKO en
// su ficha habitual, haya o no incidencia abierta. Sin lectura => «Sin lectura disponible» (nunca
// 0 %). Nunca se presenta como medición en tiempo real.
export function BateriaMoko({ bateria, deviceId }) {
  if (!bateria) return null;

  if (!bateria.disponible) {
    return (
      <p data-testid={`device-bateria-${deviceId}`} data-estado="sin_lectura"
         className="text-xs text-slate-500 mt-1 ml-6 flex items-center gap-1.5">
        <BatteryWarning strokeWidth={1.75} className="h-3.5 w-3.5 text-slate-400" />
        Batería: <span className="text-slate-500">Sin lectura disponible</span>
      </p>
    );
  }

  const pct = bateria.porcentaje;
  const critico = bateria.nivel === "inmediata";
  const bajo = bateria.nivel === "pronto";
  const Icono = bateria.cargando ? BatteryCharging : (critico || bajo) ? BatteryLow : BatteryFull;
  const tono = critico ? "text-[#9B2C2C]" : bajo ? "text-[#D97706]" : "text-emerald-600";

  return (
    <p data-testid={`device-bateria-${deviceId}`} data-estado="con_lectura" data-porcentaje={pct}
       className="text-xs text-slate-500 mt-1 ml-6 flex flex-wrap items-center gap-x-2 gap-y-0.5">
      <span className={`flex items-center gap-1.5 font-medium ${tono}`}>
        <Icono strokeWidth={1.75} className="h-3.5 w-3.5" />
        Batería: <span data-testid={`device-bateria-pct-${deviceId}`}>{pct}%</span>
      </span>
      <span aria-hidden>·</span>
      <span data-testid={`device-bateria-carga-${deviceId}`}>{bateria.estado_carga}</span>
      <span aria-hidden>·</span>
      <span data-testid={`device-bateria-leido-${deviceId}`}>
        Última lectura: {fmtTimestamp(bateria.leido_en)}
      </span>
      {bateria.nivel_etiqueta && (
        <span data-testid={`device-bateria-nivel-${deviceId}`}
              className={`rounded px-1.5 py-0.5 ${critico ? "bg-[#9B2C2C] text-white" : "bg-[#D97706] text-white"}`}>
          {bateria.nivel_etiqueta}
        </span>
      )}
      <span data-testid={`device-bateria-aviso-${deviceId}`} className="text-slate-400"
            title="El equipo reporta su batería al enviar; la consola no consulta al botón de ayuda.">
        (última lectura reportada, no es medición en tiempo real)
      </span>
    </p>
  );
}

export default BateriaMoko;
